import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: '#ffffff',
    boxSizing: 'border-box',
    padding: '16px',
    outline: 'none',
    width: '370px',
    height: 'fit-content',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '2px',
  },
  title: {
    width: '100%',
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.8)',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
  },
  save: {
    width: '89px',
    height: '36px',
    background: '#2196F3',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)',
    borderRadius: '4px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: '14px',
    color: '#FFFFFF',
    '&:hover': {
      background: '#42A5F5',
      boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
    },
  },
  close: {
    width: '72px',
    height: '36px',
    background: '#E3F2FD',
    boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.12), 0px 2px 2px rgba(0, 0, 0, 0.24)',
    borderRadius: '4px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontSize: '14px',
    color: '#2196F3',
    '&:hover': {
      background: '#42A5F5',
      boxShadow: '0px 1px 5px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 2px 4px rgba(0, 0, 0, 0.14)',
      color: '#ffffff',
    },
  },
  boxBtnFooter: {
    marginTop: '24px',
    display: 'flex',
    justifyContent: 'space-between',
  },
}))
